export class RoutesConfig {
    static general = {
        notFound: 'not-found',
        notValidPage: 'not-valid-page',
        accessDeniedPage: 'access-denied',
    };

    static pages: Record<string, string> = {
        badgeRequests: 'badge-requests',
        photoReview: 'photo-review',
        usersManagement: 'users-management',
        badgeValidityExtensions: 'badge-validity-extensions',
        employeeProfile: 'profile',
        employeeProfileTabRequestsList: 'requests-list',
        employeeBadgeRequestPage: 'employee-badge-request',
        manualActions: 'manual-actions',
        settings: 'settings',
        individualRequests: 'individual-requests',
        bulkProvision: 'bulk-provision',
        employeeSearch: 'search-employee',
        PhotoComplianceComponent: 'photo-compliance',
        PhotoComplianceRequestComponent: 'photo-compliance-request',
        locations: 'locations',
        workPermit: 'work-permit',
    };
}
